export class ListIngestionPipelineHistoryResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "history",
            "baseName": "history",
            "type": "Array<PipelineHistorySummary>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelineHistoryResponse.attributeTypeMap;
    }
    constructor() {
    }
}
